import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import TextButtonWithDocumentation from "../../../../forms/tradeplans/documentation/TextButtonDocumentation";
import WorkOrdersDoc from "../../../../forms/tradeplans/documentation/WorkOrderDocumentation";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";

export default function ExpirationWeeksAway({
  expirationWeeksAway,
  setExpirationWeeksAway,
}) {
  const [seeInputValue, setSeeInputValue] = useState(expirationWeeksAway !== 0);
  const [inputValue, setInputValue] = useState(expirationWeeksAway);
  useEffect(() => {
    setInputValue(expirationWeeksAway);
    setSeeInputValue(expirationWeeksAway !== 0);
  }, [expirationWeeksAway]);
  return (
    <Grid item container>
      <Grid item xs={6}>
        <FormControlLabel
          value="ExpirationWeeksAway"
          control={
            <Checkbox
              color="primary"
              checked={parseInt(expirationWeeksAway) === 0}
              onChange={(ev) => {
                if (ev.target.checked) {
                  setSeeInputValue(false);
                  setExpirationWeeksAway(0);
                } else {
                  setSeeInputValue(true);
                  setExpirationWeeksAway(1);
                }
              }}
            />
          }
          label={
            <Typography style={{ fontSize: 12 }}>nearest expiration</Typography>
          }
          labelPlacement="start"
        />
      </Grid>
      <Grid item xs={6}>
        {seeInputValue ? (
          <TextField
            value={inputValue}
            variant="outlined"
            size="small"
            style={{ backgroundColor: "white", width: "100%" }}
            onChange={(ev) => setInputValue(ev.target.value)}
            onBlur={(ev) => setExpirationWeeksAway(parseInt(ev.target.value))}
            label={
              <Typography style={{ fontSize: 10 }}>
                Expirations away:
              </Typography>
            }
          >
            <Typography style={{ fontSize: 1 }}>{inputValue}</Typography>
          </TextField>
        ) : (
          <></>
        )}
      </Grid>
    </Grid>
  );
}
